import { api } from '../lib/axios';

export interface NodeExecutionLogItem {
  id: string;
  flowId: string;
  nodeId: string;
  userId?: string;
  userName?: string;
  message: string;
  userMessage?: string | null;
  errorCategory?: string | null;
  errorField?: string | null;
  errorStack?: string | null;
  isError: boolean;
  createdAt: string;
  hasOutput: boolean;
  outputId?: string;
  outputType?: string;
  outputPreview?: string;
  inputPreview?: string;
  execId?: string;
  flowVersionHistoryId?: string;
  usedTokens?: number;
}

export interface NodeExecutionOutput {
  id: string;
  execId?: string;
  input?: Record<string, unknown>;
  outputData?: Record<string, unknown>;
  output?: string;
  outputType?: string;
  isError: boolean;
  flowVersionHistoryId?: string;
  createdAt: string;
}

async function getNodeExecutions(
  flowId: string,
  nodeId: string,
): Promise<NodeExecutionLogItem[]> {
  const response = await api.get<NodeExecutionLogItem[]>(
    '/executions_logs/nodes',
    { params: { flowId, nodeId } },
  );

  return response.data;
}

async function getNodeExecutionOutput(
  id: string,
): Promise<NodeExecutionOutput> {
  const response = await api.get<NodeExecutionOutput>(
    `/executions_logs/output/${id}`,
  );

  return response.data;
}

export { getNodeExecutions, getNodeExecutionOutput };
